import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { CloudinaryImage } from "../assets/CloudinaryImage.js";
import { CloudinaryVideo } from "../assets/CloudinaryVideo.js";

var Cloudinary = /*#__PURE__*/function () {
  function Cloudinary(cloudinaryConfig) {
    _classCallCheck(this, Cloudinary);

    if (cloudinaryConfig) {
      this.cloudinaryConfig = cloudinaryConfig;
    }
  }

  _createClass(Cloudinary, [{
    key: "image",
    value: function image(publicID) {
      return new CloudinaryImage(publicID, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
    }
  }, {
    key: "video",
    value: function video(publicID) {
      return new CloudinaryVideo(publicID, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
    }
  }, {
    key: "setConfig",
    value: function setConfig(cloudinaryConfig) {
      this.cloudinaryConfig = cloudinaryConfig;
      return this;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.cloudinaryConfig;
    }
  }, {
    key: "extendConfig",
    value: function extendConfig() {// Future implementation
    }
  }]);

  return Cloudinary;
}();

export { Cloudinary };